import { Pipe, PipeTransform } from '@angular/core';
import { formatTimerToHrsMinsSec } from './format.util';

@Pipe({
    standalone: false,
    name: 'timerToHrsMinsSec',
})
export class TimerToHrsMinsSecPipe implements PipeTransform {
    transform(timer: string | null | undefined): string {
        return formatTimerToHrsMinsSec(timer ?? '');
    }
}
